export default __webpack_public_path__ + "static/media/1905.3fec1c93.png";